import React, { useState } from 'react';
import axios from 'axios';
import {
    Box,
    Button,
    Checkbox,
    Container,
    FormControl,
    FormLabel,
    HStack,
    Input,
    Stack,
    Center,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useToast,
} from '@chakra-ui/react';
import { useGlobalContext } from '../context/GlobalContext';
import { PasswordField } from '../components/Login/PasswordField';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/logo.svg';
import useNavigationHistory from '../hooks/useLocation';

const Login = () => {
    const toast = useToast();
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [isOpen, setIsOpen] = useState(false); // Added state for dialog
    const onClose = () => setIsOpen(false); // Function to close dialog
    const cancelRef = React.useRef(); // Ref for cancel button in dialog

    const [, dispatch] = useGlobalContext();
    const { login } = useAuth();
    const navigate = useNavigate();
    const history = useNavigationHistory(); // Use the custom hook for navigation history

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await axios.post(process.env.REACT_APP_BACKEND_URL + "/api/users/login", {
                email: user,
                password
            });
            if (response.data && response.data.token) {
                login(response.data);
                dispatch({ type: 'SAVE_CONFIG', payload: { ...response.data, isTokenValid: true } });

                // Check if the last path in history was /login
                const lastPath = history[history.length - 2]; // Get the second last path
                console.log("lastpath", lastPath);
                if (lastPath === undefined || lastPath === '/login') {
                    navigate('/dashboard');
                }
            }
        } catch (error) {
            console.error('Login failed:', error);
            toast({
                title: "Error",
                description: error.message,
                status: "error",
                duration: 9000,
                isClosable: true,
            });
        }
    };

    const lostPassword = () => {
        console.log("Lost password");
    };

    return (
        <Container
            maxW="lg"
            py={{
                base: '12',
                md: '10',
            }}
            px={{
                base: '0',
                sm: '8',
            }}
        >
            <Stack spacing="8">
                <Box
                    as="form" // Added form tag here
                    onSubmit={handleSubmit} // Attach the handleSubmit function
                    py={{
                        base: '0',
                        sm: '8',
                    }}
                    px={{
                        base: '4',
                        sm: '10',
                    }}
                    bg={{
                        base: 'transparent',
                        sm: 'bg.surface',
                    }}
                    boxShadow={{
                        base: 'none',
                        sm: 'md',
                    }}
                    borderRadius={{
                        base: 'none',
                        sm: 'xl',
                    }}
                >
                    <Center>
                        <Logo width="200px" height="200px" />
                    </Center>
                    <Stack spacing="6">
                        <Stack spacing="5">
                            <FormControl>
                                <FormLabel htmlFor="user">Usuario</FormLabel>
                                <Input
                                    id="user"
                                    type="email"
                                    value={user}
                                    onChange={(e) => setUser(e.target.value)}
                                />
                            </FormControl>
                            <PasswordField
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Stack>
                        <HStack justify="space-between">
                            <Checkbox defaultChecked>Recordarme</Checkbox>
                            <Button variant="text" size="sm" onClick={() => setIsOpen(true)}>¿Olvidaste tu contraseña?</Button>
                        </HStack>
                        <Stack spacing="6">
                            <Button type="submit">Entrar</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Recuperar contraseña
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            Si quieres recuperar tu contraseña presiona continuar, se enviará a tu correo el proceso de recuperación.
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Cancelar
                            </Button>
                            <Button colorScheme="red" onClick={lostPassword} ml={3}>
                                Continuar
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Container>
    );
};

export default Login;
